export default __webpack_public_path__ + "static/cityair-mini-station-bd3a1138f65deca888c24ed8ee7e008a.jpg";